import { createBaseAction } from '@essent/common';

export const submitConfirmationForm = createBaseAction<{
  successPage?: string;
}>('[Confirmation] Submit Retention Confirmation');

export const submitRetentionConsents = createBaseAction(
  '[Retention] Submit retention consents'
);
